import { render, staticRenderFns } from "./HeaderBidding.vue?vue&type=template&id=01224748"
import script from "./HeaderBidding.vue?vue&type=script&lang=js"
export * from "./HeaderBidding.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports